var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchLinesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8535 23.1465L16.551 15.844C18.0678 14.1599 19 11.9395 19 9.49997C19 4.26173 14.7383 0 9.50001 0C4.26173 0 0 4.26173 0 9.50002C0 14.7383 4.26173 19 9.50001 19C11.9395 19 14.1599 18.0678 15.844 16.551L23.1465 23.8535C23.2441 23.9512 23.3721 24 23.5 24C23.6279 24 23.7559 23.9512 23.8535 23.8535C24.0488 23.6582 24.0488 23.3418 23.8535 23.1465ZM9.50001 18C4.8135 18 1.00003 14.187 1.00003 9.50002C1.00003 4.81303 4.8135 0.999984 9.50001 0.999984C14.1865 0.999984 18 4.81298 18 9.50002C18 14.187 14.1865 18 9.50001 18Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLinesIcon);
export default __webpack_public_path__ + "static/media/search_lines_icon.e0f40d2402af55bdeb6387d4cbe215fa.svg";
export { ForwardRef as ReactComponent };